export class CookieHelper {

    public static  getCookie(name: string): string {
        const nameEQ = name + "=";
        const ca = document.cookie.split(";");
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0 ; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    }

    public static eraseCookie(name) {
        document.cookie = `${name}=; Max-Age=-99999999;`;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/helpers/cookie-helper.ts